import { Map } from 'immutable';

import { actionTypes } from './actions';
import initialState from './initialState';

export default function taxAuthorityAffiliatesReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.REQUEST_START:
      return state.set('loading', true).set('data', null).set('error', null);
    case actionTypes.REQUEST_SUCCESS:
      return state
        .set('loading', false)
        .set('data', mapTaxAuthorityAffiliates(state, action.payload));
    case actionTypes.REQUEST_FAILURE:
      return state.set('loading', false).set('error', action.payload);
    default:
      return state;
  }
}

function mapTaxAuthorityAffiliates(state, payload) {
  const taxAuthorityAffiliates = { [payload.parentId]: payload.data };
  const data = state.get('data');
  const taxAuthorityAffiliatesMap = Map(taxAuthorityAffiliates);

  return data ? data.merge(taxAuthorityAffiliatesMap) : taxAuthorityAffiliatesMap;
}
